import React, { useContext } from "react";
import HaqtInput from "../../components/HaqtInput/HaqtInput";
import * as yup from "yup";
import { useFormik } from "formik";
import { postRequest } from "../../utils/api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import mailImg from "../../assests/img/mailImg.png";
import "./forgotpassword.scss";

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?!\S)/;

const validationSchema = yup.object({
  email: yup
    .string("Enter your Email")
    .matches(emailRegex, "Enter a valid email address")
    .required("Email is required"),
});

const ForgotPassword = () => {
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      resetPasswordHandler(values);
    },
  });
  const notify = (info) => toast.error(info);
  const notifySuccess = (info) => toast.success(info);
  const navigate = useNavigate();

  const resetPasswordHandler = async (values) => {
    try {
      const response = await postRequest("/Account/ForgetPassword", values);
      if (response && response.data.isSuccess) {
        formik.handleReset();
        notifySuccess("Please check your email to reset password ");
        navigate("/auth/login");
      }
    } catch (error) {
      notify(error);
    }
  };
  return (
    <>
      <div>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <HaqtInput
              fullWidth
              id="email"
              name="email"
              className="focus-placeholder"
              placeholder="Email"
              type="text"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={Boolean(formik.errors.email)}
              helperText={formik.errors.email}
              // icon={
              //   <MdOutlineEmail
              //     style={{
              //       fontSize: "24px",
              //       color: "white",
              //     }}
              //   />
              // }
              icon={<img src={mailImg} height={16} width={20} />}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{
              width: "100%",
              borderRadius: "25px",
              background: "#022C31",
              borderColor: "#022C31",
              marginBottom: "7.5rem",
            }}
          >
            Reset Password
          </button>
        </form>
      </div>
    </>
  );
};

export default ForgotPassword;
